import { useEffect, useState } from "react";
import BillingDraftProvider from "../../provider/billingDraftProvider";
import BillingTab from "./BillingTabs";
import BillingTopBar from "./topBar";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import StartCounterModal from "../cash-counter/start-counter-modal";
import { useCounterId } from "../../provider/counterProvider";
import { useLocation } from "react-router-dom";
import { useBilling } from "../Kitchen/billingProvider";
import { useAccess } from "../../provider/AccessProvider";
import { getProductDetails } from "../../service/service";
import KoTDraftProvider from "../Kitchen/KOT/draftProvider";
import { useHotkeys } from "react-hotkeys-hook";
import { useNavigate } from "react-router-dom";
import Loader from "../loader";

const Billing2 = () => {
  const [loading, setLoading] = useState(true);
  const [counterId, setCounterId] = useCounterId("");
  const [starterCounterModal, setStarterCounterModal] = useState(false);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const empId = useSelector((state) => state.shopDetails.empId);
  const dispatch = useDispatch();
  const shopData = useSelector((state) => state.shopDetails);
  const { productList } = useSelector((state) => state.products);
  const [productFetch, setProductFetch] = useState(true);
  const navigate = useNavigate();
  const {
    state: { addedProducts = [] },
    removeProductFromBilling,
    addProductToBillingFromRouterChange,
  } = useBilling();
  const access = useAccess(["generateBill"]);
  const location = useLocation();
  const getCounterOpeningDetails = async () => {
    try {
      var res = await fetch(`${config.newApiGateway}/counter/counter`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopId,
          type: "fetch",
          employeeId: empId ? empId : "",
        }),
      });
      res = await res.json();
      if (res.code === "SUCCESS") {
        if (!res.counterId) {
          setStarterCounterModal(true);
        } else {
          setCounterId(res.counterId);
        }
      }
    } catch (err) {
      console.log("Err", err);
    } finally {
      setLoading(false);
    }
  };
  const fetchData = async () => {
    try {
      let product = await getProductDetails(shopData.shopId, shopData.empId);
      if (product.products) {
        const addToLocalStroage = product?.products?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            eanCode: i.productEANCode,
            color: i.color,
            size: i.size,
            productCode: i.productCode,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: product.products,
        });
      }
      if (Array.isArray(product)) {
        const addToLocalStroage = product?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            eanCode: i.productEANCode,
            productCode: i.productCode,
            color: i.color,
            size: i.size,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: product,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setProductFetch(false);
    }
  };
  useEffect(() => {
    if (shopId) {
      getCounterOpeningDetails();
    }
    if (productList?.length === 0 && shopId) {
      fetchData();
    } else if (productList?.length > 0) {
      setProductFetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, productList]);

  useEffect(() => {
    const temp = structuredClone(addedProducts);
    temp.forEach((i) => {
      const getObj = productList.find((j) => j.productId === i.productId);

      console.log("getObj122", getObj);

      if (getObj) {
        removeProductFromBilling(i.productId);
        addProductToBillingFromRouterChange({
          ...getObj,
          count: i.count,
          isExist: true,
        });
      } else if (i.isExist === false) {
        removeProductFromBilling(i.productId);
        return i;
      } else {
        removeProductFromBilling(i.productId);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    const preventUnload = (event) => {
      if (addedProducts?.length > 0) {
        const message = "Sure you want to leave?";
        event.preventDefault();
        event.returnValue = message;
      }
    };
    window.addEventListener("beforeunload", preventUnload);
    return () => {
      window.removeEventListener("beforeunload", preventUnload);
    };
  }, [addedProducts]);

  useHotkeys("ctrl+1", () => navigate("/dashboard"));
  useHotkeys("ctrl+2", () => navigate("/billing"));
  useHotkeys("ctrl+3", () => navigate("/dashboard/shop-items"));
  useHotkeys("ctrl+4", () => navigate("/dashboard/stock-value-report"), [
    "alt",
  ]);
  useHotkeys("ctrl+5", () => navigate("/dashboard/loyalty"));
  useHotkeys("ctrl+6", () => navigate("/dashboard/customer-management"), [
    "ctrl",
  ]);
  useHotkeys("ctrl+7", () => navigate("/dashboard/vendor-management"), [
    "ctrl",
  ]);
  // useHotkeys('ctrl+F10', () =>  navigate("/dashboard/cash-management"), ['ctrl'])

  useHotkeys("alt + S", () => {
    const inputElement = document.querySelector('[data-test="search-input"]');
    inputElement.focus();
  });
  useHotkeys("alt + k", () => {
    document.getElementById("scanItem").focus();
  });
  useHotkeys("alt + p", () => {
    document.getElementById("generateBill").click();
    setTimeout(() => {
      document.getElementById("cash")?.focus();
    }, 300);
  });
  useHotkeys("alt + i", () => {
    document.getElementById("billingAddItem").click();
  });
  useHotkeys("alt + h", () => {
    document.getElementById("holdBtn").click();
  });
  useHotkeys("alt + c", () => {
    document.getElementById("customerNumberInput")?.focus();
  });
  useHotkeys("alt + d", () => {
    document.getElementById("couponDiscountBtn")?.click();
  });
  useHotkeys("alt + n", () => {
    document.getElementById("notesBtn")?.click();
  });
  useHotkeys("alt + t", () => {
    document.getElementById("advanceSettingBtn")?.click();
  });
  useHotkeys("alt + b", () => {
    document.getElementById("billSettingBtn")?.click();
  });

  useHotkeys("ctrl + 8", () => {
    navigate("/dashboard/employeeAccess");
  });
  useHotkeys("ctrl + 9", () => {
    navigate("/dashboard/settings");
  });

  useHotkeys("alt + a", () => {
    document.getElementById("deliveryAddressBtn")?.click();
  });

  return (
    <>
      {!loading && !counterId && access.generateBill(false) && (
        <StartCounterModal
          open={starterCounterModal}
          setOpen={setStarterCounterModal}
          setCounterId={setCounterId}
        />
      )}
      {productFetch && (
        <div className="loading">
          <Loader />
        </div>
      )}
      <KoTDraftProvider>
        <BillingDraftProvider>
          <BillingTopBar />
          <BillingTab />
        </BillingDraftProvider>
        {!loading && !counterId && access.generateBill(false) && (
          <StartCounterModal
            open={starterCounterModal}
            setOpen={setStarterCounterModal}
            setCounterId={setCounterId}
          />
        )}
      </KoTDraftProvider>
    </>
  );
};

export default Billing2;
